import { render, staticRenderFns } from "./expert-detail.vue?vue&type=template&id=9d20a2c0&scoped=true"
import script from "./expert-detail.vue?vue&type=script&lang=js"
export * from "./expert-detail.vue?vue&type=script&lang=js"
import style0 from "./expert-detail.vue?vue&type=style&index=0&id=9d20a2c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d20a2c0",
  null
  
)

export default component.exports